import React from 'react';
import { TrendingUp } from 'lucide-react';

export default function ChartSection() {
  const chartData = [
    { month: 'Tammikuu', organic: 1200, ai: 800, total: 2000 },
    { month: 'Helmikuu', organic: 1400, ai: 900, total: 2300 },
    { month: 'Maaliskuu', organic: 1100, ai: 1200, total: 2300 },
    { month: 'Huhhtikuu', organic: 1800, ai: 1400, total: 3200 },
    { month: 'Toukokuu', organic: 2200, ai: 1600, total: 3800 },
    { month: 'Kesäkuu', organic: 2000, ai: 1800, total: 3800 },
  ];

  const maxValue = Math.max(...chartData.map(d => d.total));

  return (
    <div className="bg-slate-800/50 backdrop-blur-xl rounded-xl p-6 border border-slate-700/50">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-bold text-white mb-2">Liikenteen kehitys</h3>
          <p className="text-slate-400">Google haku vs AI-alustat liikenne</p>
        </div>
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            <span className="text-sm text-slate-300">Orgaaninen</span>
          </div>
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
            <span className="text-sm text-slate-300">AI-alustat</span>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {chartData.map((data, index) => (
          <div key={index} className="group">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-slate-400 w-8">{data.month}</span>
              <span className="text-sm font-medium text-white">{data.total.toLocaleString()}</span>
            </div>
            <div className="relative h-8 bg-slate-700/30 rounded-lg overflow-hidden">
              <div 
                className="absolute left-0 top-0 h-full bg-gradient-to-r from-green-500 to-green-400 rounded-lg transition-all duration-1000 ease-out group-hover:shadow-lg group-hover:shadow-green-500/25"
                style={{ width: `${(data.organic / maxValue) * 100}%` }}
              ></div>
              <div 
                className="absolute h-full bg-gradient-to-r from-purple-500 to-purple-400 rounded-lg transition-all duration-1000 ease-out delay-200 group-hover:shadow-lg group-hover:shadow-purple-500/25"
                style={{ 
                  left: `${(data.organic / maxValue) * 100}%`,
                  width: `${(data.ai / maxValue) * 100}%` 
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-gradient-to-r from-green-500/10 to-purple-500/10 rounded-lg border border-green-500/20">
        <div className="flex items-center space-x-2 text-green-400 mb-1">
          <TrendingUp className="w-4 h-4" />
          <span className="text-sm font-medium">+28% kasvu tässä kuussa</span>
        </div>
        <p className="text-xs text-slate-300">AI-palveluista tuleva liikenne on kasvattanut merkittävästi</p>
      </div>
    </div>
  );
}
